'use client';
import React, { useState } from 'react';
import { Truck, Wrench, User, Plus } from 'lucide-react';
import VehicleTable from './VehicleTable';
import EquipmentTable from './EquipmentTable';
import PeopleTable from './PeopleTable';
import Icon from '@/components/ui/AppIcon';


type TabKey = 'vehicles' | 'equipment' | 'people';

const tabs: { key: TabKey; label: string; icon: React.ElementType; count: number }[] = [
  { key: 'vehicles', label: 'Vehicles', icon: Truck, count: 8 },
  { key: 'equipment', label: 'Equipment', icon: Wrench, count: 6 },
  { key: 'people', label: 'Field Personnel', icon: User, count: 12 },
];

export default function AssetManagementView() {
  const [activeTab, setActiveTab] = useState<TabKey>('vehicles');

  return (
    <div className="space-y-4 sm:space-y-5">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h1 className="text-xl sm:text-2xl font-semibold text-zinc-100">Asset Management</h1>
          <p className="text-sm text-zinc-500 mt-0.5">26 total trackable assets — vehicles, equipment, and field personnel</p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-amber-500 hover:bg-amber-400 text-zinc-950 text-sm font-semibold rounded-lg transition-all duration-150 active:scale-95 w-fit">
          <Plus size={14} /> Add Asset
        </button>
      </div>

      {/* Tabs — scrollable on mobile */}
      <div className="overflow-x-auto scrollbar-thin pb-1">
        <div className="flex items-center gap-1 bg-zinc-900 border border-zinc-800 rounded-xl p-1 w-fit min-w-full sm:min-w-0">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.key;
            return (
              <button
                key={`tab-${tab.key}`}
                onClick={() => setActiveTab(tab.key)}
                className={`flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg text-sm font-medium transition-all duration-150 whitespace-nowrap ${isActive ? 'bg-zinc-800 text-zinc-100 shadow-sm' : 'text-zinc-500 hover:text-zinc-300'}`}
              >
                <Icon size={14} />
                {tab.label}
                <span className={`text-[11px] font-bold px-1.5 py-0.5 rounded-full ${isActive ? 'bg-amber-500/20 text-amber-400' : 'bg-zinc-800 text-zinc-600'}`}>
                  {tab.count}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Tab content */}
      {activeTab === 'vehicles' && <VehicleTable />}
      {activeTab === 'equipment' && <EquipmentTable />}
      {activeTab === 'people' && <PeopleTable />}
    </div>
  );
}